import _find from "lodash/find";
import _isNil from "lodash/isNil";
import _includes from "lodash/includes";
import _parseInt from "lodash/parseInt";
import _isInteger from "lodash/isInteger";
const studentPropsMap = {
  check_index: 'index',
  check_offset: 'offset',
  check_target: 'target'
};
const isValidLiteral = atom => /^\w+$/.test(atom);
export default (atom, items) => {
  if (_isInteger(_parseInt(atom))) {
    return {
      value: _parseInt(atom)
    };
  }
  if (atom === 'True' || atom === 'False') {
    return {
      value: atom === 'True'
    };
  }
  if (_includes(atom, '(')) {
    const result = /(\w+)\((\w+)\)/g.exec(atom);
    if (!_isNil(result)) {
      const [, functionName, itemId] = result;
      if (!isValidLiteral(itemId)) {
        throw new Error("Item id ".concat(itemId, " cannot be parsed"));
      }
      const item = _find(items, {
        id: itemId
      });
      if (_isNil(item)) {
        throw new Error("Item id ".concat(itemId, " cannot be found"));
      }
      const key = studentPropsMap[functionName];
      if (_isNil(key)) {
        throw new Error("Function name (".concat(functionName, ") in ").concat(atom, " is not found"));
      }
      return {
        item,
        value: item[key]
      };
    }
  }
  if (isValidLiteral(atom)) {
    return {
      value: atom
    };
  }
  throw new Error("Target atom ".concat(atom, " cannot be parsed"));
};